import React from 'react'
import { defineBgColor, retrieveItemImageFromHero } from '@dfb/gatsby-dfb-theme/src/components/utilities'
import DfbHeadline from '@dfb/gatsby-dfb-theme/src/components/ui-kit/dfb_headline'
import DfbCard from '@dfb/gatsby-dfb-theme/src/components/elements/dfb_card'
import CEpaperCard from '@dfb/gatsby-dfb-theme/src/components/elements/c_epaper_card'
import CCardCta from '@dfb/gatsby-dfb-theme/src/components/elements/c_card_cta'
import Section from '@dfb/gatsby-dfb-theme/src/components/blocks/section'

const MCardrow = (props) => {
  let collection = props.data.collection
  collection = retrieveItemImageFromHero(collection)
  return (
    <Section
      baseClass="m-CardRow"
      className={`${props.data.grey_background ? 'u-BgColor-grey' : defineBgColor(props.data.background_color)}
          ${props.data.add_class ?? ''}`}
      defaultBgColor={'white'}
      defaultPadding="medium"
      data={{
        // remove background color, since we need a special handling here
        ...props.data,
        background_color: undefined,
      }}
    >
      <div className="m-CardRow-wrapper">
        <div className="m-CardRow-container m-CardRow-container--headline">
          <div className="c-Headline m-CardRow-headline">
            <DfbHeadline headline={props.data.headline} headline_level="h3" add_class="c-Headline-strokeLine" testid={props.data.testid} />
          </div>
          {props.data.memberCount?.number >= 0 && props.data.memberCount?.label && (
            <div className="m-CardRow-membercount">
              <span className="m-CardRow-membercount-label" data-testid="representative-membercount-label">
                {props.data.memberCount.label} {props.data.memberCount.number}
              </span>
            </div>
          )}
        </div>
        <div className={`c-CardRow m-CardRow-container${props.data.card_row_related === true ? ' c-CardRow--releated' : ''}`}>
          <div className="c-CardRow-container">
            {collection.map((item) => (
              <div key={item.uid} className="c-CardRow-card">
                {item.type === 'epaper' ? (
                  <CEpaperCard
                    data={Object.assign(item, {
                      add_class: 'dfb-Card--cover',
                    })}
                  />
                ) : item.type === 'cta' ? (
                  <CCardCta data={item} />
                ) : (
                  <DfbCard
                    data={Object.assign(item, {
                      image_aspect_ratio: '16:9',
                      add_class: 'dfb-Card--cover',
                    })}
                  />
                )}
              </div>
            ))}
          </div>
        </div>
      </div>
    </Section>
  )
}

export default MCardrow
